'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EMAIL = exports.EMAIL = 'EMAIL';
var FB_MESSENGER = exports.FB_MESSENGER = 'FB_MESSENGER';
var LIVE_CHAT = exports.LIVE_CHAT = 'LIVE_CHAT';